import { prismicSubcontentDataAdapter } from './prismic/prismicSubcontentAdapter'

export const subcontentDataAdapter = prismicSubcontentDataAdapter
